import styled from '@emotion/styled'
import { colors, fontSize, fontWeight, spacing } from '@retailer-platform/shared-components'
import React, { type FunctionComponent } from 'react'
import { TrendingIcon } from '@instacart/ids-core'
import { useDomainMessages } from 'domains/shifts/utils/domain/intl'
import { RecommendationTypeEnum } from 'domains/shifts/api'

const Container = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  backgroundColor: colors.DETRIMENTAL.LIGHT,
  margin: `${spacing.X8} -${spacing.X16}`,
  padding: spacing.X8,
})

export const NoticeBody = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
})

export const NoticeText = styled.span<{ bolded?: boolean }>(({ bolded }) => ({
  fontWeight: bolded ? fontWeight.SEMIBOLD : fontWeight.REGULAR,
  color: colors.DETRIMENTAL.REGULAR,
  fontSize: fontSize.X12,
  lineHeight: fontSize.X18,
}))

const StyledTrendingIcon = styled(TrendingIcon)({
  margin: `${spacing.X4} ${spacing.X8}`,
})

interface RecommendationShiftFormNoticeProps {
  type: RecommendationTypeEnum
}
export const RecommendationShiftFormNotice: FunctionComponent<
  RecommendationShiftFormNoticeProps
> = ({ type }) => {
  const messages = useDomainMessages({
    demandSurgeTitle: 'shiftsDomain.capacityRecommendation.demandSurgeTitle',
    demandSurgeNotice: 'shiftsDomain.capacityRecommendation.demandSurgeNotice',
    noRunnerTitle: 'shiftsDomain.capacityRecommendation.noRunnerTitle',
    noRunnerNotice: 'shiftsDomain.capacityRecommendation.noRunnerNotice',
  })

  const title: { [key in RecommendationTypeEnum]: string } = {
    [RecommendationTypeEnum.NoRunner]: messages.noRunnerTitle,
    [RecommendationTypeEnum.DemandSurge]: messages.demandSurgeTitle,
  }
  const notice: { [key in RecommendationTypeEnum]: string } = {
    [RecommendationTypeEnum.NoRunner]: messages.noRunnerNotice,
    [RecommendationTypeEnum.DemandSurge]: messages.demandSurgeNotice,
  }

  return (
    <Container>
      <StyledTrendingIcon fill={colors.DETRIMENTAL.REGULAR} size={spacing.X20} />
      <NoticeBody>
        <NoticeText bolded>{title[type]}</NoticeText>
        <NoticeText>{notice[type]}</NoticeText>
      </NoticeBody>
    </Container>
  )
}
